// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__vgUni"};